import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const CTABand = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-gold py-20 text-dark lg:py-28">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-dark/20"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full border border-dark/15"
      />
      <svg
        viewBox="0 0 100 100"
        aria-hidden="true"
        className="animate-spin-slow pointer-events-none absolute right-10 top-10 hidden h-28 w-28 opacity-70 lg:block"
      >
        <defs>
          <path id="motto-circle" d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" />
        </defs>
        <text style={{ fontSize: "9px", letterSpacing: "2px", fontFamily: "'JetBrains Mono', monospace" }} className="fill-dark">
          <textPath href="#motto-circle">ANALYZE · SOLVE · GROW · ANALYZE ·</textPath>
        </text>
      </svg>
      <div className="relative mx-auto max-w-[1440px] px-6 text-center lg:px-16">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-display text-4xl font-medium tracking-tight sm:text-5xl lg:text-6xl">
            {t.cta.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 font-mono text-xs uppercase tracking-[0.3em] text-dark/70">{t.cta.sub}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <button
            data-testid="cta-band-btn"
            onClick={() => scrollToId("kontakt")}
            className="group mt-10 inline-flex items-center gap-3 rounded-[3px] bg-dark px-8 py-4 text-xs font-semibold uppercase tracking-[0.15em] text-bone transition-colors hover:bg-bone hover:text-dark"
          >
            {t.cta.button}
            <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default CTABand;
